var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('p',{staticClass:"tips"},[_vm._v("\n    404！页面未找到！\n  ")]),_c('p',{staticClass:"btn flex flex-main-justify"},[_c('a',{on:{"click":function($event){return _vm.GO(-1)}}},[_vm._v("返回")]),_c('a',{on:{"click":function($event){return _vm.REPLACE({ path: '/main' })}}},[_vm._v("去首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }